'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToolkitAssets;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ToolkitAsset = require('./ToolkitAsset');

var _ToolkitAsset2 = _interopRequireDefault(_ToolkitAsset);

var _renderTitle = require('shared/modules/utils/renderTitle');

var _renderTitle2 = _interopRequireDefault(_renderTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToolkitAssets(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      links = _ref.links;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-toolkit_assets ' + moduleClass
    },
    (0, _renderTitle2.default)(title),
    links.map(function (_ref2, key) {
      var linkTitle = _ref2.title,
          content = _ref2.content,
          href = _ref2.href;
      return _react2.default.createElement(_ToolkitAsset2.default, {
        key: key,
        title: linkTitle,
        content: content,
        href: href
      });
    })
  );
} /*
    {
      "type": "toolkit_assets",
      "title": "Toolkit Assets Section",
      "links": [
        {
          "title": "Asset Title",
          "content": "...",
          "href": "http://path/to/asset"
        },
        {
          "title": "Another Asset Title",
          "content": "...",
          "href": "http://path/to/asset"
        }
      ]
    }
  
    A list of toolkit assets, as shown on the Generic Page Template. Contains a links
    attribute, which is an array of objects, each with a title, content, and href
    to the asset.
   */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/ToolkitAssets/ToolkitAssets.jsx
// module id = 1265
// module chunks = 0